module.exports = __webpack_public_path__ + "static/media/hair.d0cc5997.png";